import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function DFAdministered() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px] overflow-hidden" data-id="element-840">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-841">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-842">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-843">
            <span className="text-white uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-844">
              Be POWERFUL
            </span>

            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-845">
              HOW ARE THEY ADMINISTERED?
            </h2>

            <div className="space-y-6 text-white text-base leading-[1.8] font-body" data-id="element-846">
              <p data-id="element-847">
                Dermal fillers are typically administered using tiny needles,
                contributing to a relatively comfortable and minimally invasive
                experience for patients. The needles used during the procedure
                are fine-gauge and carefully selected to ensure precision in
                injecting the filler into targeted areas of the face. The small
                size of these needles helps to minimize discomfort and reduce
                the risk of bruising or swelling at the injection sites.
              </p>
              <p data-id="element-848">
                Before the procedure, we apply a topical numbing cream to the
                treatment areas to further enhance client comfort. This numbing
                agent helps alleviate any potential sensation during the
                injection process. The use of tiny needles and numbing agents
                contributes to a more tolerable experience, making dermal filler
                treatments accessible to individuals with varying pain
                thresholds.
              </p>
              <p data-id="element-849">
                Additionally, many dermal fillers are formulated with lidocaine
                or other local anesthetics, which are integrated into the filler
                solution. This means that as the filler is being injected, the
                anesthetic component helps to further minimize discomfort.
                Clients often describe the sensation as a slight pinch or
                pressure, and any temporary discomfort is typically brief.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-850">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-2xl" data-id="element-851">
              <img src="https://cdn.magicpatterns.com/uploads/kzkQbjnmq85JrDhN1RCYk9/AdobeStock_257206406-5.webp" alt="Dermal Filler Administration at Be CLINICAL" className="w-full h-full object-cover" data-id="element-852" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}